<template>
  <b-container>
    <b-col class="mt-2">

      <b-row class="form-group">
        <b-col offset="4" md="8" align="right">
          <b-button class="clear" @click="clearFilterData()">
            {{ $t("label_advancedData_clearFilters") }}
          </b-button>
          <b-button variant="primary" @click="setComparativeDataFromPromise()">
            {{ $t("label_advancedData_applyFilters") }}
          </b-button>
        </b-col>
      </b-row>
      <!-- Filters -->
      <template-filters ref="filters" :multiple-years="true" />
      <!-- GeneralIndex -->
      <b-row v-if="!$store.getters.getIsLoading && isDataReady">
        <b-col>
          <card-chart-compare
            ref="general-index"
            :title="$t('label_reports_genderGap_genderEqualityIndex_title')"
            :description="'label_reports_genderGap_genderEqualityIndex_description'"
            :alias="'GeneralIndex'"
            :key-value="'index'"
            :chart-data="comparativeData.generalIndex"
          />
        </b-col>
      </b-row>
      <!-- End GeneralIndex -->

      <!-- Pillars -->
      <template v-if="isDataReady">
        <b-row v-for="(chart, key) in comparativeData.pillars" :key="key">
          <b-col>
            <card-chart-compare
              :title="getChartTitle(chart)"
              :description="chart.description"
              :alias="key"
              :key-value="'index'"
              :chart-data="chart.generalIndex"
            />
          </b-col>
        </b-row>
      </template>
      <!-- End Pillars -->

      <!-- Conventions -->
      <template v-if="!$store.getters.getIsLoading">
        <b-row class="form-group">
          <b-col>
            <card-conventions
              :height="'auto'"
              :orientation="'horizontal'"
              :show-ideal="false"
              :show-company="false"
            />
          </b-col>
        </b-row>
      </template>
      <!-- End Conventions -->
    </b-col>
  </b-container>
</template>
<script >
import { mapGetters } from "vuex";
import cardChartCompareComponent from "@/components/cards/CardChartCompare.vue";
import CardChartCompare from "@/components/cards/CardChartCompare.vue";

export default {
  name: "ReportsComparative",
  components: { CardChartCompare },
  props: {
    alias: {
      default: "",
    },
  },
  data: function () {
    return {
      comparativeData: {
        generalIndex: [],
        pillars: {},
      },
      isDataReady: false
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapGetters(["getToken"]),
  },
  watch: {},
  created: async function () {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
  },
  mounted: function () {
    this.setComparativeDataFromPromise();
    this.$store
      .dispatch("PILLARS_GLOBAL_IDS_GET")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    getChartTitle: function (chart) {
      if (chart.acronym) {
        return `${this.$t(chart.acronym)} - ${this.$t(chart.name)}`;
      }
      return this.$t(chart.name);
    },
    setComparativeDataFromPromise: async function () {
      this.isDataReady = false
      await this.getComparativeData()
        .then((comparativeData) => {
          comparativeData.generalIndex.map((gi) => {
            gi.businessName =
              this.$t(gi.businessName) +
              (gi.companyCounter ? " " + gi.companyCounter : "") +
              (gi.year ? ` (${gi.year})` : "");
            return gi;
          });

          Object.keys(comparativeData.pillars).map((pillar) => {
            comparativeData.pillars[pillar].generalIndex.map((gi) => {
              gi.businessName =
                this.$t(gi.businessName) +
                (gi.companyCounter ? " " + gi.companyCounter : "") +
                (gi.year ? ` (${gi.year})` : "");
              return gi;
            });
          });
          this.comparativeData = comparativeData;
          this.isDataReady = true
        })
        .catch(() => {
          this.isDataReady = true
        });
    },
    getGeneralIndexData() {
      return {
        generalIndex: this.comparativeData.generalIndex,
      };
    },
    clearFilterData() {
      if (this.$refs.filters) {
        this.$refs.filters.clearFilters();
      }
      this.setComparativeDataFromPromise();
    },
    getComparativeData() {
      let parameters = {
        Companies: [],
        Tags: [],
        Years: [],
        Types: [],
        Locations: [],
        Sizes: [],
        Activities: [],
      };
      if (this.$refs.filters) {
        parameters = this.$refs.filters.getDataInFilters();
      }
      return this.$store.dispatch("COMPAREPILLARS_REPORT", parameters);
    },
  },
};
</script >

<style lang="sass" scoped >
.tab-pane
  &.card-body
    padding-top: 1.5rem

.clear
  background-color: #72c6c0
  border: 0
  margin-right: 5px
</style >
